export default __webpack_public_path__ + "static/media/Landing Page-01-300k.2413ba6f.png";